













import Fieldset from '~/components/car/classifieds/form/fieldsets/handlers/Fieldset.vue'
import BaseFieldsetMixin from '~/components/car/classifieds/form/fieldsets/handlers/BaseFieldsetMixin.vue'
import { defineComponent } from '@nuxtjs/composition-api'

export default defineComponent({
  components: { Fieldset },
  mixins: [BaseFieldsetMixin]
})
